import { useFindCertificatesKpi } from "~/gen/api"

export const useFindCertificatesKpiQuery = () => useFindCertificatesKpi()
